import Vue from "vue"

const success = (context, user) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  let message = 'User '+(user.active ? 'activated' : 'deactivated')+' successfully';
  swal("Done!", message, "success");
  context.fetch_users();
  context.disableSubscriptionBtn = false;
};

const failed = (context, error) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Error!", error.response.data.msg, "warning");
  context.disableSubscriptionBtn = false;
};


export default (context, user, data) => {
  return Vue.$http.put('/users/'+user.id+'/change-status', data).then((response) => {
    if (response && response.status === 200) {
      success(context, user);
    }
  }).catch((error) => {
    failed(context, error);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/admin/changeStatus.js